define(["require", "exports", "./types", "./utils"], function (require, exports, types_1, utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getPointPositionInPX = exports.getDisplayQuadrant = exports.isPointUnderLine = exports.getLineInInterceptForm = exports.getLine = exports.findIndexOfNearestSegmentLine = exports.findIndexOfNearestOpenedPoint = exports.findIndexOfPointAroundThreshold = exports.distanceFromPointToSegmentLine = exports.angleBetweenPoints = exports.distanceFromPointToPoint = exports.isPointInBoundingBox = void 0;
    const isPointInBoundingBox = (point, bb) => utils_1.isPointInInterval(point, bb.A, bb.B);
    exports.isPointInBoundingBox = isPointInBoundingBox;
    const distanceFromPointToPoint = (v, w) => v.minus(w).length();
    exports.distanceFromPointToPoint = distanceFromPointToPoint;
    const angleBetweenPoints = (A, B, C) => {
        const a = exports.distanceFromPointToPoint(B, C);
        const b = exports.distanceFromPointToPoint(C, A);
        const c = exports.distanceFromPointToPoint(A, B);
        return Math.acos((Math.pow(a, 2) + Math.pow(c, 2) - Math.pow(b, 2)) / (2 * c * a));
    };
    exports.angleBetweenPoints = angleBetweenPoints;
    const distanceFromPointToSegmentLine = (point, line) => {
        const lineDirection = line.P2.minus(line.P1);
        if (lineDirection.isZero()) {
            return exports.distanceFromPointToPoint(point, line.P1);
        }
        // 1. length of vector `point - P1` projected on `P2 - P1` = length(point - P1) * cos(point, P1, P2)
        // 2. normalised by lenght of `P2 - P1`
        // 3. bounded by 0, 1 (to omit a case when projection is out of `line`)
        const t = utils_1.clamp(lineDirection.dotProduct(point.minus(line.P1)) / lineDirection.dotProduct(lineDirection), 0, 1);
        return exports.distanceFromPointToPoint(point, line.P1.plus(lineDirection.multiply(t)));
    };
    exports.distanceFromPointToSegmentLine = distanceFromPointToSegmentLine;
    const findIndexOfPointAroundThreshold = (point, points, threshold) => 
    // find first element from `points` for which `point` is in squere box around it
    points.findIndex((pt) => exports.isPointInBoundingBox(point, {
        A: pt.minus(new types_1.Vector2(threshold, threshold)),
        B: pt.plus(new types_1.Vector2(threshold, threshold)),
    }));
    exports.findIndexOfPointAroundThreshold = findIndexOfPointAroundThreshold;
    const findIndexOfNearestOpenedPoint = (point, points) => {
        if (points.length === 0)
            return -1;
        const firstPoint = points[0];
        const lastPoint = points[points.length - 1];
        return exports.distanceFromPointToPoint(point, firstPoint) > exports.distanceFromPointToPoint(point, lastPoint)
            ? points.length - 1
            : 0;
    };
    exports.findIndexOfNearestOpenedPoint = findIndexOfNearestOpenedPoint;
    const findIndexOfNearestSegmentLine = (point, points) => {
        const { length } = points;
        if (length < 3) {
            return length - 1;
        }
        let minDistance = Infinity;
        let closestSegment = -1;
        for (let i = 0; i < length; i += 1) {
            const distance = exports.distanceFromPointToSegmentLine(point, {
                P1: points[i],
                P2: points[(i + 1) % length],
            });
            if (distance <= minDistance) {
                minDistance = distance;
                closestSegment = i;
            }
        }
        // check if closest point to `point` is either end of the segment
        let closestPoint = null;
        if (exports.distanceFromPointToPoint(points[closestSegment], point) <= minDistance + 1e-9) {
            closestPoint = closestSegment;
        }
        if (exports.distanceFromPointToPoint(points[(closestSegment + 1) % length], point) <= minDistance + 1e-9) {
            closestPoint = (closestSegment + 1) % length;
        }
        if (closestPoint != null) {
            const [a, b, c] = utils_1.getSubPolygon(points, closestPoint - 1, 3);
            return exports.angleBetweenPoints(a, b, point) <= exports.angleBetweenPoints(point, b, c)
                ? (closestPoint - 1 + length) % length
                : closestPoint;
        }
        // if neither of the segment points are closest, return the segment
        return closestSegment;
    };
    exports.findIndexOfNearestSegmentLine = findIndexOfNearestSegmentLine;
    const getLine = (point1, point2) => {
        // line defined by 2 points
        // some better sulution if points are not equal???
        if (point1.equals(point2))
            return { a: 0, b: 0, c: 0 };
        if (point1.x === point2.x)
            return { a: 1, b: 0, c: -point1.x };
        if (point1.y === point2.y)
            return { a: 0, b: -1, c: point1.y };
        const slope = (point1.y - point2.y) / (point1.x - point2.x);
        return {
            a: slope,
            b: -1,
            c: point1.y - slope * point1.x,
        };
    };
    exports.getLine = getLine;
    const getLineInInterceptForm = (point, slope) => ({
        // I do not know how to rewrite it in ImageZoom.tsx.
        // But this is consistent with old old function. Can be `aspectRatio` infinity?
        a: slope,
        b: -1,
        c: slope * -point.x + point.y,
    });
    exports.getLineInInterceptForm = getLineInInterceptForm;
    const isPointUnderLine = (point, line) => {
        if (line.b === 0)
            return false;
        return point.y < (line.a * point.x + line.c) / -line.b;
    };
    exports.isPointUnderLine = isPointUnderLine;
    const getDisplayQuadrant = (origin, point) => {
        if (origin.x <= point.x && origin.y <= point.y) {
            return types_1.Quadrant.BottomRight;
        }
        if (origin.x >= point.x && origin.y <= point.y) {
            return types_1.Quadrant.BottomLeft;
        }
        if (origin.x <= point.x && origin.y >= point.y) {
            return types_1.Quadrant.TopRight;
        }
        return types_1.Quadrant.TopLeft;
    };
    exports.getDisplayQuadrant = getDisplayQuadrant;
    const getPointPositionInPX = (point, canvasSize, zoom = 1) => new types_1.Vector2(point.x * canvasSize.width, point.y * canvasSize.height).divide(zoom);
    exports.getPointPositionInPX = getPointPositionInPX;
});
//# sourceMappingURL=graphics.js.map